export const LIST_FOLDER_REQUEST="LIST_FOLDER_REQUEST";
export const LIST_FOLDER_SUCCESS="LIST_FOLDER_SUCCESS";
export const LIST_FOLDER_FAIL="LIST_FOLDER_FAIL";
